module.exports = __webpack_public_path__ + "img/product-content-1.f14a9653.png";